import { render, staticRenderFns } from "./ApproveChangeEmail.vue?vue&type=template&id=70131115"
import script from "./ApproveChangeEmail.vue?vue&type=script&lang=js"
export * from "./ApproveChangeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports